import React, { useRef } from "react";
import { Box, TextField } from "@mui/material";

export default function OTPInput({ length = 6, value = "", onChange }) {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const val = e.target.value;
    if (!/^[0-9]?$/.test(val)) return; // only digits
    const otpArray = value.split("");
    otpArray[index] = val;
    const newOtp = otpArray.join("");
    onChange(newOtp);

    // move to next field automatically
    if (val && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1.5,
        mt: 1,
      }}
    >
      {Array.from({ length }).map((_, index) => (
        <TextField
          key={index}
          variant="outlined"
          value={value[index] || ""}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          inputRef={(el) => (inputRefs.current[index] = el)}
          slotProps={{
            input: {
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "1rem",
                fontWeight: 200,
                padding: "10px 0",
                width: "2.3rem",
                backgroundColor: "#fff",
                height: "2.5rem",
              },
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              "& fieldset": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
              "&:hover fieldset": {
                borderColor: "primary.main",
              },
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
                boxShadow: (theme) =>
                  `0 0 0 2px ${theme.palette.primary.main}33`,
              },
            },
            "& input": {
              textAlign: "center",
              color: "text.primary",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.text.disabled,
            },
          }}
        />
      ))}
    </Box>
  );
}
